export const environment = {
  production: false,
  apiUrl: 'https://dev-portal-api.gastro-management.ch/api',
  devApiUrl: 'https://dev-developer-api.gastro-management.ch/api',
  // My-SPA (Kundenkonto): the one place for language and appearance, which apply in every app.
  myUrl: 'https://dev-my.gastro-management.ch',
  auth0: {
    domain: 'gastro-management.eu.auth0.com',
    clientId: 'zYOIYAW0ybBkJBtuUY3eBSLdmXiaU1z2',
    audience: 'https://api.gastro-management.ch',
  }
};
